export const authenticated = "authenticated";
export const token = "token";
export const login = "login";
export const uploading = "uploading";
export const current = "current";
export const disable_next_button = "disable";
export const username = "username";
export const error = "error";
export const isLoading = "isLoading";
export const headerKeys = "keys";
export const menuTitle = "menuTitle";
export const callApiLabel = "callApi";